import { initializeApp } from "firebase/app";
import { getFirestore, collection, doc } from "firebase/firestore";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Root Access Helpers - matches SYSTEM.md structure
export const ROOT_COLLECTION = 'uchena';
export const ROOT_DOC = 'main';

export const rootCollection = (name, ...rest) =>
  collection(db, ROOT_COLLECTION, ROOT_DOC, name, ...rest);

export const rootDoc = (name, ...rest) =>
  doc(db, ROOT_COLLECTION, ROOT_DOC, name, ...rest);

export { db };
